import { api } from '@/lib/api/client';
import type {
  ChangePasswordRequest,
  LoginRequest,
  Me,
  UpdateProfileRequest,
} from './types';

/**
 * 인증 API 호출.
 *
 * 토큰을 다루지 않는다. 세션 쿠키를 브라우저가 자동으로 실어 보내므로
 * 프론트가 자격증명을 들고 있을 일이 없다.
 * 이것이 JWT 대신 서버 세션을 고른 이유 중 하나다 —
 * localStorage 에 토큰을 두면 XSS 한 번에 그대로 새어 나간다.
 */

export async function login(request: LoginRequest): Promise<Me> {
  return api.post<Me>('/auth/login', request);
}

export async function logout(): Promise<void> {
  await api.post<void>('/auth/logout');
}

/**
 * 현재 로그인 상태를 확인한다.
 *
 * 로그인하지 않았으면 401(A004)이 떨어진다.
 * "로그인했는지" 를 묻는 별도 엔드포인트가 없는 이유다.
 */
export async function fetchMe(): Promise<Me> {
  return api.get<Me>('/auth/me');
}

/**
 * 본인 정보 수정. (내 정보 화면)
 *
 * 대상 id 를 보내지 않는다. 서버가 세션에서 꺼낸다.
 * 보내면 그 자리가 남의 계정을 고치는 입구가 된다.
 */
export async function updateProfile(request: UpdateProfileRequest): Promise<Me> {
  return api.put<Me>('/auth/me', request);
}

/**
 * 본인 비밀번호 변경.
 *
 * @returns 끊긴 다른 기기 수. 지금 이 기기는 유지된다
 */
export async function changePassword(request: ChangePasswordRequest): Promise<number> {
  return api.post<number>('/auth/me/password', request);
}
